// Generated by scripts/generate-icons.ts from @phosphor-icons/react; change the table there.
import { icon } from "#components/icons/icon";

export const XIcon = icon(
  "M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z",
);
